import { render } from "./SeasonStats.vue?vue&type=template&id=998c0668&scoped=true"
import script from "./SeasonStats.vue?vue&type=script&lang=ts"
export * from "./SeasonStats.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-998c0668"

export default script